import { boolean, object, optional, string } from 'superstruct';

export const dashboardConfigSchema = object({
  showFullTimeStamp: optional(boolean()),
  metricDetailsMasonryConfigKey: optional(string()),
  allRecordedDataMasonryConfigKey: optional(string()),
  labs: optional(
    object({
      labResultsLandingMasonryConfigKey: string(),
      labResultDetailsMasonryConfigKey: optional(string()),
    }),
  ),
});
